import React from 'react';
import Grid from '../Grid';
import ReadMoreLink from '../ReadMoreLink';
import {
  SecureStyled,
  Article,
  TextBlock,
  Title,
  Description,
  Link,
  Figure,
  TopLogo
} from './styled';

const Secure = () => {
  return (
    <SecureStyled>
      <Grid>
        <Article>
          <TextBlock>
            <Title>Security</Title>
            <Description>
              With Universal login, users are redirected to a central authorization server. Because
              authentication is taking place on the same domain as the login, credentials are not
              sent across origins, increasing security and protecting against attacks such as
              phishing and bucket brigade attack (sometimes called a man-in-the-middle attack).
            </Description>
            <ReadMoreLink
              Href="https://auth0.com/docs/guides/login/universal-vs-embedded"
              Rel="external"
            >
              Learn More
            </ReadMoreLink>
          </TextBlock>
          <Figure>
            <img
              src="https://cdn.auth0.com/website/universal-login/security-login-final.svg"
              alt=""
            />
          </Figure>
        </Article>
        <Article>
          <TextBlock className="desktop-swap">
            <TopLogo>
              <img
                src="https://cdn.auth0.com/website/assets/pages/homepage/img/std_cert/oauth2-360e300bd3.svg"
                alt=""
              />
            </TopLogo>
            <Title>Securing Mobile Apps</Title>
            <Description>
              OAuth 2.0 recommends that only external user agents (such as the browser) should be
              used by native applications for authentication flows. Universal login provides this in
              a secure manner while also enabling SSO.
            </Description>
          </TextBlock>
          <Figure className="desktop-swap">
            <img
              className="mobile"
              src="https://cdn.auth0.com/website/universal-login/ul-secure-app-device-5.svg"
              alt=""
            />
            <img
              className="desktop"
              src="https://cdn.auth0.com/website/universal-login/iphone-with-shield-new.svg"
              alt=""
            />
          </Figure>
        </Article>
      </Grid>
    </SecureStyled>
  );
};

export default Secure;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Secure/Secure.js